import React, { useEffect } from "react";
import styled from "styled-components/macro";
import { useDispatch, useSelector } from "react-redux";
import { setAppBackdrop } from "features/appBackdrop/appBackdropSlice";
import { zIndexes } from "theme/Theme";
import CartDropdownData from "./CartDropdownData";
import { updateCartData } from "./cartSlice";
import { ProductCartItem } from "./types";

interface Props {
  onClickOutside: () => void;
  removeElementWithId: (id: string) => void;
  updateCallback: (newItems: any[]) => void;
  emptyMessage: string;
  actionButtonTitle: string;
  actionButtonRoute: string;
  items: any[];
  actionButtonIcon?: any;
  showCount?: boolean;
}

const MobileCartDropdown: React.FC<Props> = ({
  onClickOutside,
  removeElementWithId,
  emptyMessage,
  actionButtonTitle,
  actionButtonIcon,
  actionButtonRoute,
  showCount = true,
  items,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setAppBackdrop(true));
    return () => {
      dispatch(setAppBackdrop(false));
    };
  }, [dispatch]);

  return (
    <>
      <DrawerContainer>
        <CartDropdownData
          listedItems={items}
          removeElementWithId={removeElementWithId}
          emptyMessage={emptyMessage}
          actionButtonTitle={actionButtonTitle}
          actionRoute={actionButtonRoute}
          actionButtonIcon={actionButtonIcon}
          onClickOutside={onClickOutside}
          showCount={showCount}
        />
      </DrawerContainer>

      <DrawerOverlay onClick={onClickOutside} />
    </>
  );
};
const DrawerContainer = styled.div`
  box-sizing: border-box;
  z-index: ${zIndexes.drawer};
  position: absolute;
  width: 100vw;
  max-height: inherit;
  bottom: 55px;
  left: 0;
  background-color: white;
  overflow: auto;
  padding: 5px;
`;

const DrawerOverlay = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  bottom: 0;

  z-index: ${zIndexes.backdrop + 1};
`;

export default MobileCartDropdown;
